import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

import def_avatar from '../../assets/img/default_avatar.png'

Vue.use(Vuex)

const initialState = {
	accountId: '',
	userId: '',
	userMask: '',
	languageCode: '',
	conversations: [],
	convoEvents: {}, // map of [conversation id] => events list
	user: {},
	account: {},
	agents: [],
	widgetSetting: {},
	accountSetting: {},
	fcmToken: null,
	defaultAvatar: def_avatar,
	windowMode: 'full', // full | mini
	position: 'right', // right | left
	dateFormat: 'YYYY-MM-DD',
	viewport: {},
	originViewport: {},
	modifiedViewport: {
		'maximum-scale': '1.0',
		'user-scalable': 'no',
		width: 'device-width',
		'initial-scale': '1.0',
	},
	now: new Date(),
	convoListEnd: false,
	allReady: false,
	userReady: false,
	baseSettingReady: false,
	settingReady: false,
	wsReady: false,
	cssReady: false,
	languageReady: false,
	convoListReady: false,
	lastConvoId: '',
	eventAnchors: {},
	eventLimit: 100,
	eventEnds: {},
	connectionId: '',
	geoIP: {},
	themeColor: '#4285f4',
	customScreens: {},
	lastScreenId: '',
	isOffline: false,
	isHovering: false,
	focusMessageInput: false,
	device: {},
	domReady: false, // vue instance is ready
	parent_href: '',
	parent_title: '',
}

const cloneDeep = o => JSON.parse(JSON.stringify(o))

const state = Object.assign({}, cloneDeep(initialState), {
	initial: cloneDeep(initialState),
})

const store = new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
})

export default store
